export default "__VITE_ASSET__B$eOobrx__"